import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_ARROW_LEFT_RIGHT: GlameraIconDefinition = {
  name: 'arrow-left-right',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-arrow-left-right-left">
      <path d="M8 3 4 7l4 4"></path>
      <path d="M4 7h16"></path>
    </g>
    <g class="glm-arrow-left-right-right">
      <path d="m16 21 4-4-4-4"></path>
      <path d="M20 17H4"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-arrow-left-right-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './arrow-left-right.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ArrowLeftRightIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_ARROW_LEFT_RIGHT;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
